import { useSelector, useDispatch} from "react-redux"
import PanelLoading from "../../PanelLoading"
import PanelInfiniteScroll from "../PanelInfiniteScroll"
import ImportedArticle from "../../articles/ImportedArticle"
import {
	selectNoteArticleTabHasMore,
	selectCurrentNoteArticleTab,
	selectNoteArticleTabPage,
	selectNoteArticleTabsArticles,
	selectNoteArticleTabsCurrentIndexV2,
	selectNoteArticleTabsIsLoading,
	updateNoteArticleAsImported,
	incrementPageAndFetchArticles
} from "../../../reducers/noteArticleTabsV2Slice"
import RawArticle from "../../articles/RawArticle"
import { selectNoteAttachmentMap } from "../../../reducers/noteAttachmentsSlice"
import Attachment from "../../workspace/note_tree/Attachments/NoteAttachment/Attachment"
import { Box, Collapse, Typography } from "@mui/material"
import { ArrowRight } from "@mui/icons-material"

import { useState } from "react"
import {useTabPanelScrollEl} from "../../panels/TabPanel"
import {useWorkspaceContext} from "../../../pages/Dashboard"
import {useUnassignedArticleIds} from "../../../hooks/MemoizedSelectors"
import {getArticleTargetKey} from "../../../utils/articleUtilities"
export function NoteArticleList() {
	
	const dispatch = useDispatch()
	const {workspaceId} = useWorkspaceContext()
	const isLoading = useSelector((state) => selectNoteArticleTabsIsLoading(state, workspaceId))
	const articles = useSelector((state) => selectNoteArticleTabsArticles(state, workspaceId))
	const unassignedArticleIds = useUnassignedArticleIds()
	const tab = useSelector((state) => selectCurrentNoteArticleTab(state, workspaceId))
	const setArticleAsImported = (article) => dispatch(updateNoteArticleAsImported({article, workspaceId}))
	const tabPage = useSelector((state) => selectNoteArticleTabPage(state, workspaceId))
	const noteAttachmentsMap = useSelector((state) => selectNoteAttachmentMap(state, workspaceId))
	const currentNoteId = useSelector((state) => selectNoteArticleTabsCurrentIndexV2(state, workspaceId))
	const hasMore = useSelector((state) => selectNoteArticleTabHasMore(state, workspaceId))
	const [open, setOpen] = useState(true)
	const scrollableTarget = useTabPanelScrollEl()
	
	const handleClick = () => {
		setOpen(!open)
	}

	const rotateStyle = {
		transform: open ? "rotate(90deg)" : "rotate(0deg)", 
		transition: "transform 150ms ease",
	}

	const paginate = () => {
		if (hasMore) {
			const note = tab?.meta?.note 
			dispatch(incrementPageAndFetchArticles({
				tab, note, page: tabPage + 1, singleNote: tab.singleNote
			}))
		}
	}

	return (
		<div>
			{isLoading && articles.length === 0 ? (
				<PanelLoading />
			) : (
				<>
					{
						noteAttachmentsMap[currentNoteId]?.length > 0 && (
							<Box sx={{padding: "8px"}} >
								<Box sx={{display: "flex", alignItems: "center", cursor: "pointer"}} onClick={handleClick}>
									<ArrowRight  sx={{
										...rotateStyle,
										fontSize: "2rem"
									}}/>
									<Typography
										variant={"body1"}
										sx={{
											marginBottom: 0,
											wordBreak: "break-word"
										}}
										paragraph
									>
										Note Attachments
									</Typography>
								</Box>


								<Collapse in={open} timeout="auto" unmountOnExit>
									<PanelInfiniteScroll
										dataLength={noteAttachmentsMap[currentNoteId]?.length}
										hasMore={false}
										loader={<PanelLoading />}
										fitContent={true}
										scrollableTarget={scrollableTarget.current}
									>
										{
											noteAttachmentsMap[currentNoteId]?.map((attachment) => {
												return (
													<Box key={attachment.id} sx={{marginY: "8px"}} >
														<Attachment attachment={attachment}/>
													</Box>
												)
											})
										}
									</PanelInfiniteScroll>
								</Collapse>
							</Box>
						)
					}
					<PanelInfiniteScroll
						dataLength={articles.length}
						hasMore={hasMore}
						next={paginate}
						loader={<PanelLoading />}
						scrollableTarget={scrollableTarget.current}
						fitContent
					>
						{articles.map((article, index) => {
							if (article.articleId && article.deletedAt === null) {
								return (
									<ImportedArticle
										key={article.articleId}
										articleWorkspace={article}
										isUnassigned={unassignedArticleIds.includes(article.articleId)}
										index={index}
									/>
								)
							} else {
								let rawArticle = article.articleId ? article.article : article
								return (
									<RawArticle
										key={getArticleTargetKey(rawArticle)}
										workspaceId={workspaceId}
										article={rawArticle}
										setArticleAsImported={setArticleAsImported}
										index={index}
										deletedAt={article.deletedAt}
									/>
								)
							}
						})}
					</PanelInfiniteScroll>
				
				</>
			)}
		</div>
	)
}